import apiClient from './client';

export const listClients = (params) => apiClient.get('/clients', { params }).then((r) => r.data);
export const getClient = (id) => apiClient.get(`/clients/${id}`).then((r) => r.data);
export const getClientHistory = (id) => apiClient.get(`/clients/${id}/history`).then((r) => r.data);
export const createClient = (payload) => apiClient.post('/clients', payload).then((r) => r.data);
export const updateClient = (id, payload) => apiClient.put(`/clients/${id}`, payload).then((r) => r.data);
export const setClientStatus = (id, status) => apiClient.patch(`/clients/${id}/status`, { status }).then((r) => r.data);
export const setClientPassword = (id, newPassword) => apiClient.patch(`/clients/${id}/password`, { newPassword }).then((r) => r.data);
export const setClientAssignedEmployees = (id, employeeIds) => apiClient.patch(`/clients/${id}/assigned-employees`, { employeeIds }).then((r) => r.data);
export const deleteClient = (id) => apiClient.delete(`/clients/${id}`).then((r) => r.data);
